import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminPaymentSubmitButton = ({
  disabled,
  currentPriceId,
  selectedPriceId,
  processing,
  handleCheckout,
  handleChangePlan,
}) => {
  const intl = useIntl();

  if (!selectedPriceId) {
    return null;
  }

  return (
    <div className="button-wrapper">
      {currentPriceId ? (
        <Button
          color="primary"
          disabled={processing || selectedPriceId === currentPriceId || disabled}
          onClick={() => {
            handleChangePlan(selectedPriceId);
          }}
        >
          {processing ?
            intl.formatMessage({ defaultMessage: 'Wait...' }) :
            intl.formatMessage({ defaultMessage: 'Update' })}
        </Button>
      ) : (
        <Button
          color="primary"
          disabled={processing || disabled}
          onClick={() => {
            handleCheckout(selectedPriceId);
          }}
        >
          {processing ?
            intl.formatMessage({ defaultMessage: 'Wait...' }) :
            intl.formatMessage({ defaultMessage: 'Subscribe' })}
        </Button>
      )}
    </div>
  );
};

AdminPaymentSubmitButton.propTypes = {
  disabled: PropTypes.bool,
  selectedPriceId: PropTypes.string,
  currentPriceId: PropTypes.string,
  processing: PropTypes.bool.isRequired,
  handleCheckout: PropTypes.func.isRequired,
  handleChangePlan: PropTypes.func.isRequired,
};

AdminPaymentSubmitButton.defaultProps = {
  disabled: false,
  selectedPriceId: null,
  currentPriceId: null,
};

export default AdminPaymentSubmitButton;
